<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <Breadcrumbs headline="Thiết lập phân quyền" :link="[{ text: 'Phân quyền', href: '../settings' }]" />
    </div>

    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <ConfigRoleFilter @onFilterChanged="onFilterChanged" />
    </v-card>

    <div v-if="action.state === 'select'" class="elevation-0">
      <RoleBlankView />
    </div>
    <v-card v-else outlined class="mx-4 elevation-0">
      <component
        :is="action.options[action.state]"
        :role="selectedRole || {}"
        :rolePolicies="selectedRolePoliciesCode"
        @updatePolicies="updatePolicies"
      />
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { get } from 'lodash'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import RoleBlankView from '@/modules/setting/RoleBlankView.vue'
import ConfigRoleFilter from '@/modules/setting/ConfigRoleFilter.vue'

import StudentPolicy from '@/modules/policy/StudentPolicyForm'
import TeacherPolicy from '@/modules/policy/TeacherPolicyForm'
import TeacherDocPolicy from '@/modules/policy/TeacherDocPolicyForm'
import ClassPolicy from '@/modules/policy/ClassPolicyForm'
import SchedulePolicy from '@/modules/policy/SchedulePolicyForm.vue'
import DraftSchedulePolicyForm from '@/modules/policy/DraftSchedulePolicyForm.vue'
import BusPolicy from '@/modules/policy/BusPolicyForm.vue'
import DocumentPolicy from '@/modules/policy/DocumentPolicyForm.vue'
import ContactBookPolicy from '@/modules/policy/ContactBookPolicyForm.vue'
import AdvancePolicy from '@/modules/policy/AdvancePolicyForm.vue'
import RolePolicyForm from '@/modules/policy/RolePolicyForm.vue'
import FeedbackPolicy from '@/modules/policy/FeedbackPolicyForm.vue'
import FinancePolicy from '@/modules/policy/FinancePolicyForm.vue'
import DishServicePolicy from '@/modules/policy/DishServicePolicyForm.vue'
import ExamPolicy from '@/modules/policy/ExamPolicyForm.vue'
// import StaffPolicy from '@/modules/policy/StaffPolicyForm'
import TaskManagerPolicy from '@/modules/policy/TaskManagerPolicyForm.vue'
import SalaryPolicy from '@/modules/policy/SalaryPolicyForm.vue'
import StudentCreditPolicyForm from '../../modules/policy/StudentCreditPolicyForm.vue'
import StudentTicketPolicyForm from '../../modules/policy/StudentTicketPolicyForm.vue'
import OtherPolicyForm from '../../modules/policy/OtherPolicyForm.vue'

export default {
  components: {
    Breadcrumbs,
    ConfigRoleFilter,

    StudentPolicy, // Học sinh
    TeacherPolicy, // Giáo viên
    ClassPolicy, // Lớp học
    BusPolicy, // Xe tuyến
    SchedulePolicy, // Thời khóa biểu
    DraftSchedulePolicyForm, // Thời khóa biểu* (thank tra)
    FinancePolicy, // Tài chính
    DishServicePolicy, // Dịch vụ bếp
    ContactBookPolicy, // Sổ liên lạc
    AdvancePolicy, // Nâng cao
    FeedbackPolicy, // Phản hồi
    RolePolicyForm, // Quản trị hệ thống
    TaskManagerPolicy, // Quản lý tác vụ
    // StaffPolicy, // Nhân viên
    DocumentPolicy, // Sổ sách báo cáo
    TeacherDocPolicy, // Sổ sách giáo viên
    RoleBlankView,
    StudentCreditPolicyForm,
    ExamPolicy, // Kỳ kiểm tra
    StudentTicketPolicyForm, // Ticket học phí
    OtherPolicyForm // Hoạt động khác
  },

  async created() {
    await Promise.all([this.fetchRoles(), this.fetchPolicies({ _limit: -1 })])
  },
  data() {
    return {
      action: {
        state: 'select',
        options: {
          select: null,
          studentForm: StudentPolicy,
          classForm: ClassPolicy,
          busForm: BusPolicy,
          documentForm: DocumentPolicy,
          // staffForm: StaffPolicy,
          teacherForm: TeacherPolicy,
          scheduleForm: SchedulePolicy,
          draftScheduleForm: DraftSchedulePolicyForm,
          contactBookForm: ContactBookPolicy,
          advanceForm: AdvancePolicy,
          feedbackForm: FeedbackPolicy,
          roleForm: RolePolicyForm,
          financeForm: FinancePolicy,
          dishServiceForm: DishServicePolicy,
          taskManagerForm: TaskManagerPolicy,
          salaryForm: SalaryPolicy,
          teacherDocForm: TeacherDocPolicy,
          studentCreditPolicyForm: StudentCreditPolicyForm,
          studentTicket: StudentTicketPolicyForm,

          examPolicyForm: ExamPolicy,
          otherPolicyForm: OtherPolicyForm
        }
      },
      selectedRole: {},
      selectedRolePoliciesCode: []
    }
  },
  computed: {
    ...mapState('policies', ['policies'])
  },
  methods: {
    ...mapActions('auth', ['setAuthPolicies']),
    ...mapActions('role', ['fetchRoles', 'updateRolePolicies']),
    ...mapActions('policies', ['fetchPolicies']),
    getPoliciesCodeFromIds(IDs) {
      return this.policies.reduce((codes, policy) => {
        if (IDs.includes(policy.id)) {
          codes.push(policy.code)
        }
        return codes
      }, [])
    },
    getPoliciesIdFromCodes(codes) {
      return this.policies.reduce((IDs, policy) => {
        if (codes.includes(policy.code)) {
          IDs.push(policy.id)
        }
        return IDs
      }, [])
    },
    onFilterChanged(params) {
      this.selectedRole = params.role
      this.selectedRolePoliciesCode = this.getPoliciesCodeFromIds(get(this.selectedRole, 'policies', []))
      const configForm = params.config
      switch (configForm) {
        case 'student': {
          this.action.state = 'studentForm'
          break
        }
        case 'class': {
          this.action.state = 'classForm'
          break
        }
        // case 'staff': {
        //   this.action.state = 'staffForm'
        //   break
        // }
        case 'teacher': {
          this.action.state = 'teacherForm'
          break
        }
        case 'teacherDoc': {
          this.action.state = 'teacherDocForm'
          break
        }
        case 'schedule': {
          this.action.state = 'scheduleForm'
          break
        }
        case 'schedule-draft': {
          this.action.state = 'draftScheduleForm'
          break
        }
        case 'bus': {
          this.action.state = 'busForm'
          break
        }
        case 'document': {
          this.action.state = 'documentForm'
          break
        }
        case 'contactBook': {
          this.action.state = 'contactBookForm'
          break
        }
        case 'advance': {
          this.action.state = 'advanceForm'
          break
        }
        case 'feedback': {
          this.action.state = 'feedbackForm'
          break
        }
        case 'setting': {
          this.action.state = 'roleForm'
          break
        }
        case 'finance': {
          this.action.state = 'financeForm'
          break
        }
        case 'dishService': {
          this.action.state = 'dishServiceForm'
          break
        }
        case 'task': {
          this.action.state = 'taskManagerForm'
          break
        }
        case 'salary': {
          this.action.state = 'salaryForm'
          break
        }
        case 'balance': {
          this.action.state = 'studentCreditPolicyForm'
          break
        }
        case 'studentTicket': {
          this.action.state = 'studentTicket'
          break
        }
        case 'exam': {
          this.action.state = 'examPolicyForm'
          break
        }
        case 'others': {
          this.action.state = 'otherPolicyForm'
          break
        }
        default: {
          this.action.state = 'select'
        }
      }
    },
    async updatePolicies(policies) {
      const policiesID = this.getPoliciesIdFromCodes(policies)
      const updateData = { id: this.selectedRole.id, policies: policiesID }
      this.$loading.active = true
      await this.updateRolePolicies(updateData)
      this.$loading.active = false
      // Cập nhật policy trong auth store cho role đăng nhập hiện tại
      if (this.$auth.role.id === this.selectedRole.id) {
        this.setAuthPolicies(policies)
      }
    }
  }
}
</script>
<style scoped></style>
